'use strict';

export * from "./config.js";
//# sourceMappingURL=index.js.map